import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { CategoryModel, ContextModel } from '@bayclubs/group-classes-employee-api';
import { TextMaskService } from '@bayclubs/ui-text-mask';

import { Providers } from '../../../interfaces/interfaces.module';
import { DataFilteringService } from '../../../shared/shared.module';
import { ProviderPayratesFormBuilderService } from '../../services/provider-payrates-form-builder.service';



@Component({
    selector: 'app-provider-payrates-edit',
    templateUrl: './provider-payrates-edit.component.html',
    styleUrls: ['./provider-payrates-edit.component.scss'],
    standalone: false
})
export class ProviderPayratesEditComponent implements OnInit {
    @Input()
    form: UntypedFormGroup;

    @Input()
    clubs: Providers.ClubModel[];

    @Input() managementContext: ContextModel;
    categories: CategoryModel[];

    clubCategories: { id: string; displayedName: string; grouping: string }[] = [];

    constructor(
        public mask: TextMaskService,
        private formBuilder: ProviderPayratesFormBuilderService,
        private route: ActivatedRoute,
        private filteringService: DataFilteringService
    ) {}

    private initializeCategories(): void {
        const providerClubIds = this.clubs.map(c => c.id);
        const availableClubIds = this.managementContext.clubs.filter(c => providerClubIds.includes(c.id)).map(c => c.id);
        const availableCategories = this.filteringService.getAvailableCategoriesByClubs(
            availableClubIds,
            this.managementContext
        );
        this.categories = availableCategories;
        this.clubCategories = this.managementContext.clubGroupClassCategories
            .filter(x => x.jobCostCode !== null && availableClubIds.indexOf(x.clubId) >= 0)
            .map(x => {
                return {
                    id: x.id,
                    displayedName: x.categoryName + ' | ' + x.jobCostCode + ' | ' + x.clubCode,
                    grouping: x.clubCode
                };
            });
    }

    get categorySpecificPayRatesArray(): UntypedFormArray {
        return this.form.get('payRates') as UntypedFormArray;
    }

    ngOnInit() {
        this.initializeCategories();
    }

    public onRemovePayRate(index: number) {
        this.formBuilder.removeCategorySpecificPayRate(this.form, index);
    }

    public onAddCategorySpecificPayRate() {
        this.formBuilder.addCategorySpecificPayRate(this.form);
    }
}
